import { useAuth } from "@clerk/nextjs";
import { useRouter } from "next/compat/router";
import { useEffect } from "react";

const useScrollToHash = () => {
	const router = useRouter();
	const { isLoaded } = useAuth();

	useEffect(() => {
		// const hashSegment = router?.asPath.match(/#.*/)?.[0]
		// hashSegment && document.querySelector(hashSegment)?.scrollIntoView()
	}, [router?.asPath, isLoaded]);
};

export default useScrollToHash;
